import { Box, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { DataProvider } from '../../../Core/DataProvider'
import { BannersType } from '../Banners'
import ImageZoom from '../../../Components/ImageZoom/ImageZoom'

const RECOURCE = 'banners'

export function BannerDetail() {
    const id = useParams().id
    const [loading, setLoading] = useState(false)
    const [banner, setBanner] = useState<BannersType | null>(null)
    const getBanner = async () => {
        setLoading(true)
        let response = await DataProvider.get<BannersType>(`${RECOURCE}/${id}/`)
        if (response) {
            setBanner(response.data)
        }
        setLoading(false)
    }

    useEffect(() => {
        getBanner()
    }, [])

    return (
        <Stack p={4} direction={'column'} spacing={2.5}>
            <Typography variant="h6" fontWeight="600" sx={{ fontSize: '18px !important', mb: 1 }}>
                جزئیات بنر
            </Typography>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{
                    xs: 1,
                    sm: 0.5,
                }}
            >
                <Typography variant="body1" sx={{ fontWeight: '600', fontSize: '17px' }}>
                    آیدی:
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: '400', fontSize: '16px' }}>
                    {banner?.id}
                </Typography>
            </Stack>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{
                    xs: 1,
                    sm: 0.5,
                }}
            >
                <Typography variant="body1" sx={{ fontWeight: '600', fontSize: '17px' }}>
                    عنوان:
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: '400', fontSize: '16px' }}>
                    {banner?.title}
                </Typography>
            </Stack>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{
                    xs: 1,
                    sm: 0.5,
                }}
            >
                <Typography variant="body1" sx={{ fontWeight: '600', fontSize: '17px' }}>
                    ساب تایتل:
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: '400', fontSize: '16px' }}>
                    {banner?.subtitle || '--'}
                </Typography>
            </Stack>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{
                    xs: 1,
                    sm: 0.5,
                }}
            >
                <Typography variant="body1" sx={{ fontWeight: '600', fontSize: '17px' }}>
                    لینک:
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: '400', fontSize: '16px' }}>
                    {banner?.url}
                </Typography>
            </Stack>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{
                    xs: 1,
                    sm: 0.5,
                }}
            >
                <Typography variant="body1" sx={{ fontWeight: '600', fontSize: '17px' }}>
                    وضعیت:
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: '400', fontSize: '16px' }}>
                    {banner?.active ? 'فعال' : 'غیرفعال'}
                </Typography>
            </Stack>
            <Stack direction={'column'} spacing={1}>
                <Typography variant="body1" sx={{ fontWeight: '600', fontSize: '17px' }}>
                    تصویر:
                </Typography>

                <ImageZoom>
                    <Box
                        component={'img'}
                        sx={{
                            width: {
                                xs: '200px',
                                sm: '250px'
                            },
                            height: {
                                xs: '200px',
                                sm: '250px'
                            },
                            borderRadius: 2,
                            objectFit: 'fill',
                        }}
                        src={typeof banner?.image === 'string' ? banner?.image : ''}
                        borderRadius={2}
                    />
                </ImageZoom>
            </Stack>
        </Stack>
    )
}
